import type { CardId, WallCard } from '@walls/store';

export function findCardById(cards: WallCard[], cardId: CardId | null): WallCard | null {
  if (!cardId) {
    return null;
  }

  for (const card of cards) {
    if (card.id === cardId) {
      return card;
    }

    const childCard = findCardById(card.cards, cardId);

    if (childCard) {
      return childCard;
    }
  }

  return null;
}

export function findParentClusterByCardId(
  cards: WallCard[],
  cardId: CardId | null
): WallCard | null {
  if (!cardId) {
    return null;
  }

  for (const card of cards) {
    if (card.cards.some((childCard) => childCard.id === cardId)) {
      return card;
    }

    const parentCluster = findParentClusterByCardId(card.cards, cardId);

    if (parentCluster) {
      return parentCluster;
    }
  }

  return null;
}
